import {Flex, Radio} from "antd";
import {blue} from "@ant-design/colors";
import {SelectOption} from "../../types/inputTypes";
import { ReactNode } from 'react';
import { HugeiconsIcon } from "@hugeicons/react";
import { Hold01Icon } from "@hugeicons/core-free-icons";

interface CustomRadioGroupProps {
  options: { value: any, label: string, description?: string, icon?: ReactNode }[],
  value?: any,
  onChange?: (value: any) => void,
}

const RadioCards = ({options, onChange, value}: CustomRadioGroupProps) => {
  return (
    <div className={'flex flex-col gap-2'}>
      {options.map((item) => (
        <div className={`flex gap-3 bg-slate-50 px-4 py-2 rounded-lg cursor-pointer items-center border ${value === item.value ? 'bg-white border-slate-500': 'border-slate-200'}`} onClick={() => {
          if (onChange) {
            onChange(item.value);
          }
        }} key={item.value}>
          {/*<Radio checked={value === item.value}/>*/}
          <div className={`aspect-square p-1 rounded-md ${value === item.value ? 'bg-primary': ''}`}>
            {item.icon}
          </div>
          <div>
            <p className={'font-medium'}>
              {item.label}
            </p>
            <p className={'text-slate-500'}>{
              item.description
            }</p>
          </div>
        </div>
      ))}
    </div>);
}
export default RadioCards;
